var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVaknlLgTransfer = function SvgVaknlLgTransfer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#282828",
    fillRule: "nonzero",
    transform: "translate(5 11)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.2,
    height: 8,
    x: 0.6,
    rx: 1.199
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.2,
    height: 8,
    x: 26.2,
    rx: 1.199
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F3AD05",
    fillRule: "nonzero",
    d: "M11.078 9.626h17.843v3.598H11.078z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M11.548 33.715v-2.818m16.904 2.818v-2.818"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D9B8B",
    fillRule: "nonzero",
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M31.858 17.711 30.811 10a3.534 3.534 0 0 0-2.727-2.974A38.413 38.413 0 0 0 20 6.285c-2.71-.04-5.416.209-8.073.741A3.52 3.52 0 0 0 9.2 10l-1.047 7.711c-.1.73-.15 1.465-.153 2.202v8.744a2.694 2.694 0 0 0 2.716 2.672h18.568A2.685 2.685 0 0 0 32 28.657v-8.744a16.718 16.718 0 0 0-.142-2.202h0zm-3.491 2.818H11.633a1.07 1.07 0 0 1-.789-.32 1.07 1.07 0 0 1-.302-.797l.654-8.358a1.068 1.068 0 0 1 1.091-.96h15.426a1.068 1.068 0 0 1 1.091.96l.654 8.358a1.066 1.066 0 0 1-1.091 1.117z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F3AD05",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(10 23)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.826,
    cy: 2.094,
    r: 1.957
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.174,
    cy: 2.094,
    r: 1.957
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#288374",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.25 8.007s1.539-.783 9.75-.783 9.75.783 9.75.783M9.565 30.442h20.87M8 26.79a2.695 2.695 0 0 0 2.716 2.671h18.568A2.687 2.687 0 0 0 32 26.79"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M31.858 17.711 30.811 10a3.534 3.534 0 0 0-2.727-2.974A38.413 38.413 0 0 0 20 6.285c-2.71-.04-5.416.209-8.073.741A3.52 3.52 0 0 0 9.2 10l-1.047 7.711c-.1.73-.15 1.465-.153 2.202v8.744a2.694 2.694 0 0 0 2.716 2.672h18.568A2.685 2.685 0 0 0 32 28.657v-8.744a16.718 16.718 0 0 0-.142-2.202h0zm-3.491 2.818H11.633a1.07 1.07 0 0 1-.789-.32 1.07 1.07 0 0 1-.302-.797l.654-8.358a1.068 1.068 0 0 1 1.091-.96h15.426a1.068 1.068 0 0 1 1.091.96l.654 8.358a1.066 1.066 0 0 1-1.091 1.117z"
  }))));
};
export default SvgVaknlLgTransfer;